import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import { Dropdown, SearchElement } from 'shared/ui'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import { DateDropdownContent } from 'widgets/SearchDropdown/ui/DropdownContent/DateDropdownContent/DateDropdownContent'
import { type SearchDropdownDateStore } from 'widgets/SearchDropdown/store/searchDropdownDateStore'
import { SearchDateEnum } from 'widgets/SearchDropdown/model/types'

type DateElementProps = {
  parentsDropdownId?: string[]
  store: SearchDropdownDateStore
  onRemove: (type: SearchTypesEnum) => void
  activeType: SearchTypesEnum | null
  canShowChildDropdown: boolean
}

export const DateElement: FC<DateElementProps> = observer(
  ({ parentsDropdownId, store, onRemove, activeType, canShowChildDropdown }) => {
    const { hasDate, hasOneOfDate, dateType, from, to } = store

    const title = () => {
      switch (dateType) {
        case SearchDateEnum.today:
          return 'Today'
        case SearchDateEnum.yesterday:
          return 'Yesterday'
        case SearchDateEnum.last30days:
          return 'Last 30 days'
        case SearchDateEnum.last90days:
          return 'Last 90 days'
        case SearchDateEnum.custom:
          const startYear = from?.getFullYear() ?? ''
          const endYear = to?.getFullYear() ?? ''

          if (startYear === endYear)
            return `${dayjs(from).format('MMM D')} - ${dayjs(to).format('MMM D, YYYY')}`
          return `${dayjs(from).format('MMM D, YYYY')} - ${dayjs(to).format('MMM D, YYYY')}`
      }
    }

    return (
      <Dropdown
        ariaLabel={'DateElement'}
        parentsDropdownId={parentsDropdownId}
        iconButtonProps={{
          size: 'medium',
          fontSize: 20,
          ariaLabel: 'DateElement_trigger',
        }}
        show={activeType === SearchTypesEnum.date && canShowChildDropdown}
        triggerComponent={(open) => (
          <SearchElement
            icon={'calendar'}
            type='Created date'
            removeCallback={() => {
              onRemove(SearchTypesEnum.date)
            }}
            content={hasDate && title()}
            warningContent={!open && !hasDate}
            contentDefaultValue={hasOneOfDate ? 'Custom' : 'select'}
          />
        )}
        placement={'bottom-start'}
        sizeTriggerButton={'medium'}
        variantTriggerButton={'icon'}
        customComponent={(onCloseMenu) => (
          <DateDropdownContent store={store} onCloseMenu={onCloseMenu} />
        )}
      />
    )
  }
)
